// React i hooks
import { memo } from "react";

// Tipovi i konstante
import { UserDetailProps } from "./types";

// UI komponente
import UserInfoCard from "./components/UserInfoCard/UserInfoCard";

const UserDetailCard: React.FC<UserDetailProps> = (props) => {
  const { user, fetchUser } = props;

  return (
    <>
      <UserInfoCard user={user} fetchUser={fetchUser} />
    </>
  );
};
export default memo(UserDetailCard);
